export const POPOVERS_MOUNT_NODE        =   document.getElementById('react-application-mount-node');
export const DIAGRAMS_LIST_MOUNT_NODE   =   document.getElementById('react-diagram-list');
export const SESSION_MOUNT_NODE         =   document.getElementById('react-session-mount-node');
/* eslint id-length: 0 */
export const KEY_CODES = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,

    PAUSE_BREAK: 19,
    CAPSLOCK: 20,
    ESCAPE: 27,

    SPACE: 32,

    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,

    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,

    INSERT: 45,
    DELETE: 46,

    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    /* eslint-disable id-length */
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    /* eslint-enable id-length */

    WINDOW_KEY_LEFT: 91,
    WINDOW_KEY_RIGHT: 92,
    SELECT_KEY: 93,

    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,

    MULTIPLY: 106,
    ADD: 107,
    SUBTRACT: 109,
    DECIMAL_POINT: 110,
    DIVIDE: 111,

    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,

    NUMLOCK: 144,
    SCROLLLOCK: 145,
    SEMI_COLON: 186,
    EQUAL_SIGN: 187,
    COMMA: 188,
    DASH: 189,
    PERIOD: 190,
    FORWARD_SLASH: 191,
    GRAVE_ACCENT: 192,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRAKET: 221,
    SINGLE_QUOTE: 222
};
/* eslint id-length: 1 */

const hasProperty = Object.prototype.hasOwnProperty;

export function isNumberKeyCode(keyCode) {
    return isInRangeEq(keyCode, KEY_CODES.ZERO, KEY_CODES.NINE) || isInRangeEq(keyCode, KEY_CODES.NUM_ZERO, KEY_CODES.NUM_NINE);
}

export function isLetterKeyCode(keyCode) { return isInRangeEq(keyCode, KEY_CODES.A, KEY_CODES.B);  }

export function isNavigationKey(keyCode) {
    return (keyCode === KEY_CODES.TAB)
        || (keyCode === KEY_CODES.ARROW_LEFT)
        || (keyCode === KEY_CODES.ARROW_RIGHT)
        || (keyCode === KEY_CODES.ARROW_UP)
        || (keyCode === KEY_CODES.ARROW_DOWN);
}

export function isFunctionalKey(keyCode) { return isInRangeEq(keyCode, KEY_CODES.F1, KEY_CODES.F12); }

export function isRemoveKey(keyCode) { return KEY_CODES.BACKSPACE === keyCode || KEY_CODES.DELETE === keyCode; }

export function redirect(href) {
    const testPageIndicator = document.getElementById('test-page');
    if ((testPageIndicator && testPageIndicator.value) || 'NodeJs JsDom' === navigator.userAgent) { return href; }
    window.location = href;
}

export function getBrowserSize() {
    if ('undefined' === typeof window) { return { width: 0, height: 0 }; }
    const documentElement = document.documentElement;
    const body = document.getElementsByTagName('body')[0];
    return {
        width : window.innerWidth  || documentElement.clientWidth  || body.clientWidth,
        height: window.innerHeight || documentElement.clientHeight || body.clientHeight
    };
}

export function getConstructor(testValue) {
    const FIRST_CHAR = 0;
    const USELESS_PART = 8; // "[object " in "[object <Type>]"
    const typeRaw = Object.prototype.toString.call(testValue).substr(USELESS_PART);
    const CLOSING_BRACKET = typeRaw.length - 1;
    return typeRaw.substr(FIRST_CHAR, CLOSING_BRACKET).toLowerCase();
}

export function validateEmail(email) {
    const regexp = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    return regexp.test(email);
}

export function createReducerSwitch(state) {
    const reducerSwitcher = {
        _state: state,
        _storage: {}
    };
    function _assignHandler(storage, action, handler) {
        if (undefined === storage[action]) {
            storage[action] = handler;
            return;
        }
        const actionHandlers = storage[action];
        const isHandlersArray = actionHandlers instanceof Array;
        if (isHandlersArray) {
            const isUniqueHandler = actionHandlers.every((_handler) => _handler !== handler);
            if (isUniqueHandler) {
                actionHandlers.push(handler);
                return;
            }
            console.warn(`Found duplicated handler for ${action}`);
            return;
        }
        storage[action] = [handler];
    }
    /* eslint-disable no-invalid-this */
    function __on__(action, handler) {
        if (undefined === action) { return this; }
        const isArray = action instanceof Array;
        const isString = 'string' === typeof action;
        if (!isString && !isArray) { throw new Error(`"action" argument must be a string or an array of strings`); }
        if ('function' !== typeof handler) { throw new Error(`"handler" argument must be a function`); }
        if (isArray) {
            action.forEach((actionName) => {
                if ('string' !== typeof actionName) {
                    throw new Error(`"action" argument must be a string or an array of strings. ${actionName} is not a string`);
                }
                _assignHandler(this._storage, actionName, handler);
            });
        } else {
            _assignHandler(this._storage, action, handler);
        }
        return this;
    }
    function __reduce__(action) {
        const handler = this._storage[action.type];
        if (undefined === handler) { return this._state; }
        return handler(this._state, action);
    }
    /* eslint-enable no-invalid-this */
    reducerSwitcher.on = __on__.bind(reducerSwitcher);
    reducerSwitcher.reduce = __reduce__.bind(reducerSwitcher);
    return reducerSwitcher;
}

export function reducerPipe(state, action, pipeHandler) {
    if ('function' === typeof pipeHandler) { return pipeHandler(state, action); }
    /* eslint no-use-before-define: 0 */
    function _makePipeObject(_state, _action) {
        return {
            pipe: __pipe__.bind(null, _state, _action),
            pipeOut: __pipeOut__.bind(null, _state, _action),
            out: __out__.bind(null, _state)
        };
    }

    function __pipe__(_state, _action, handler) {
        const newState = handler(_state, _action);
        return _makePipeObject(newState, _action);
    }

    function __pipeOut__(_state, _action, _handler) { return _handler(_state, _action); }

    function __out__(_state) { return _state; }

    return _makePipeObject(state, action);
}

export function generateUID() {
    return Number(String(Math.random()).substr(2)).toString(36);
}

export function isEmptyValue(value) {
    return undefined === value || null === value || '' === value;
}

export function getProp(target, propString, divider = '.') {
    if ('object' !== typeof target) { throw new TypeError('getProp(): target is not an object'); }
    if (isEmptyValue(propString) || 'string' !== typeof propString) {
        throw new TypeError('getProp(): propString is not a string');
    }
    if (isEmptyValue(divider) || 'string' !== typeof divider) {
        throw new TypeError('getProp(): divider is not a string');
    }
    const propPathArray = propString.split(divider);
    const LAST_PROP_INDEX = propPathArray.length - 1;
    let lastProp = target;
    for (let propIndex = 0; propIndex <= LAST_PROP_INDEX; propIndex++) {
        const propName = propPathArray[propIndex];
        const prop = lastProp[propName];
        if (prop) {
            lastProp = prop;
        } else {
            throw new ReferenceError();
        }
    }
    return lastProp;
}

export function getPropsOrDefault(target, propString, defaultValue, divider = '.') {
    //try {
    //    return getProp(target, propString, divider);
    //} catch (err) {
    //    return defaultValue;
    //}
    if ('object' !== typeof target) { throw new TypeError('getProp(): target is not an object'); }
    if (isEmptyValue(propString) || 'string' !== typeof propString) {
        throw new TypeError('getProp(): propString is not a string');
    }
    if (isEmptyValue(divider) || 'string' !== typeof divider) {
        throw new TypeError('getProp(): divider is not a string');
    }
    const propPathArray = propString.split(divider);
    const LAST_PROP_INDEX = propPathArray.length - 1;
    let lastProp = target;
    for (let propIndex = 0; propIndex <= LAST_PROP_INDEX; propIndex++) {
        const propName = propPathArray[propIndex];
        const prop = lastProp[propName];
        if (prop) {
            lastProp = prop;
        } else {
            return defaultValue;
            //throw new ReferenceError();
        }
    }
    return lastProp;
}

export function rangeIter(from, to, callback, IGNORE_EQUALS = false) {
    let _from = from;
    if ('function' !== typeof callback) { throw new TypeError('rangeIter(): callback is not a function'); }
    if (from === to && !IGNORE_EQUALS) { throw new RangeError('rangeIter(): `from` value equal to `to`'); }
    if (from < to) {
        for (; _from < to; _from++) { callback(_from); }
    } else {
        for (; _from > to; _from--) { callback(_from); }
    }
}

export function rangeIterEq(from, to, callback) {
    let _from = from;
    if ('function' !== typeof callback) { throw new TypeError('rangeIter(): callback is not a function'); }
    if (from < to) {
        for (; _from <= to; _from++) { callback(_from); }
    } else {
        for (; _from >= to; _from--) { callback(_from); }
    }
}

export function holdWithMin(value, min) { return value > min ? value : min; }
export function holdWithMinEq(value, min) { return value >= min ? value : min; }

export function holdWithMax(value, max) { return value < max ? value : max; }
export function holdWithMaxEq(value, max) { return value <= max ? value : max; }

export function holdInRange(value, min, max) {
    if (min > max) { throw new RangeError(`holdInRange(): min value ${min} is greater than max ${max} vaue`); }
    return holdWithMin(
        holdWithMax(value, max),
        min
    );
}

export function holdInRangeEq(value, min, max) {
    if (min > max) { throw new RangeError(`holdInRange(): min value ${min} is greater than max ${max} vaue`); }
    return holdWithMinEq(
        holdWithMaxEq(value, max),
        min
    );
}

export function isInRange(value, min, max) {
    if (min > max) { throw new RangeError(`isInRange(): min value ${min} is greater than max ${max} vaue`); }
    return ((min < value) && (max > value));
}

export function isInRangeEq(value, min, max) {
    if (min > max) { throw new RangeError(`isInRange(): min value ${min} is greater than max ${max} vaue`); }
    return ((min <= value) && (max >= value));
}

export function delay(delayLengthInMs) {
    return new Promise((resolve) => {
        setTimeout(resolve, delayLengthInMs);
    });
}

/* Return TRUE if objects are different and FALSE if they are identical */
export function compareObjects(left, right) {
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    const allKeys = leftKeys.concat(rightKeys);
    return allKeys.some((fieldName) => left[fieldName] !== right[fieldName]);
}

export function compareObjectsInclusive(left, right, keys) {
    return keys.some((fieldName) => left[fieldName] !== right[fieldName]);
}

export function compareObjectsExclusive(left, right, keys) {
    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    const allKeys = leftKeys.concat(rightKeys).filter((key) => !keys.includes(key));
    return allKeys.some((fieldName) => left[fieldName] !== right[fieldName]);
}

export function getSearchString() {
    const { search_string: sentSearchString } = window.location.search.slice(1).split('&')
        .reduce((acc, next) => {
            const key = next.split('=');
            acc[key[0]] = key[1];
            return acc;
        }, {});
    return sentSearchString ? decodeURI(sentSearchString) : '';
}

export function has(object, property) {
    return hasProperty.call(object, property);
}
